import type { Epic } from 'Flux/index.ts'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.ts'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const CreateOrderDraftEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.createOrderDraftRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.createOrderDraft(action.payload, state.authentication.user).pipe(
        mergeMap((response) => of(order.createOrderDraftSuccess(response))),
        catchError((error: Error) => of(order.createOrderDraftFailure({ error })))
      )
    )
  )
